'use strict';

import React, { Component } from 'react';

import Form from 'react-jsonschema-form';
import Dialog from '../../../commonModules/interface/Dialog.jsx';
import { Close, Create, WbSunny, Settings } from '@material-ui/icons';
import { IconButton, Button, Box, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import DisplayUserInfo from './DisplayUserInfo';
import { TableLayout } from '../Stock/containers/Layout.jsx';
var $ = require('jquery');

class ProfileItemGenerics extends Component{
    state = {
        ItemName: '',

        AC: '',
        DC: '',
        values:'',
        info:'',
        openNewEquip:false,
        form2: {},
        formAC: {
            definitions:{},
            properties:{
                ac:{}, 
            }
        },
        formDC: {
            definitions:{},
            properties:{
                dc:{}, 
            }
        },
        formType:"",
        form: {
            jsonSchema:{
                properties:{
                    ac:{},
                    dc:{},
                }
            },
            uiSchema:{}
        },
        showUpdateForm:"",
        update:false,
    }
   
    componentDidMount() {
        this.getGenercisInfo()
    }
    isJson(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
    getGenercisInfo() { 
        var methodName = 'getGenercisInfo';
        
        var urlBoxFreeOfAssociation = "/userinfo/info/all?boxAssoId=" + this.props.boxAssoId+"&info="+this.props.InfoItem;
        // if (this.props.userId === ''){
        //     console.log('[DEBUG], ', methodName, ' userID empty ,',this.props.boxId);
        //     urlBoxFreeOfAssociation = "userinfo/info/all?userID=" + this.props.boxId+"&info="+this.props.InfoItem;
        // }
        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            var AC = '';
            var DC = '';
            var values = '';
            var ItemName = '';
            try {
                var data = result.info; //var data = JSON.parse(result);
                if (this.isJson(data) ){
                    values =data === "nullerr" ? "" :JSON.parse(data);
                }else{
                    values = data === "nullerr" ? "" : data;
                }
                AC = values.ac;
                DC = values.dc;
                ItemName = result.FormsName;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            
            this.setState({
              AC: AC,
              DC: DC,
              values:values,
              info:values,
              ItemName: ItemName,
            });
        }.bind(this));
    }
    componentWillUnmount() {
      try{
      }catch(e){
        console.log(e);
      }
    }
    getSchema= async () => {
        console.log('[INFO] get Schema equipment user');
            this.setState({
                update:!this.state.update,
                MenuUserInfoStatus: 'dropdown'
            })
            var idInfo = this.props.userId;
            if (idInfo === ''){
                idInfo = this.props.boxId;
            }
            try {
                const infos = await fetch('/schema/getCustomSchema',{
                    method:'POST',
                    headers: { 
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    body:JSON.stringify({
                        "idSchema":this.props.InfoItem,
                        "userID":idInfo
                    }),
                    
                    credentials: 'same-origin',
                });
                let body = await infos.json();                
                let schema = JSON.parse(body.jsonSchema)
                console.log('[INFO], schema recu',schema);
                // body = body === null ? [] : body
                this.setState({
                    form2:schema,
                    formAC :{
                        title :schema.title,
                        type:schema.type,
                        definitions:schema.definitions,
                        properties:{
                            ac:schema.properties.ac
                        }
                    },
                    formDC :{
                        title :schema.title,
                        type:schema.type,
                        definitions:schema.definitions,
                        properties:{
                            dc:schema.properties.dc
                        }
                    },
                    form:{
                        uiSchema:body.uiSchema? JSON.parse(body.uiSchema) : body.uiSchema,
                        jsonSchema:schema.definitions.Color,

                    },
                    schemaID:body.schemaID,
                    
                })
                    
                console.log("[INFO] get Schema equipment user, respose ",body,  this.state);  

            } catch (error) {
                console.log("[ERROR] get Schema equipment user",error)
                return
            }
    }
    updateInfo(values, field) {
        console.log('[INFO] get forms profile user');
        
        const schema = this.state.form.jsonSchema.properties;
        const ui = this.state.form.uiSchema
        console.log("FIELD & schema UPDATE INFO", field, schema);
        
        if(values){
            let display = values[field];//copy value prevent changing real value
            let specificSchema = {};//will contain current json schema
            let specificUi = {};//will contain current ui schema
            let formDatas = {};//will contain current Db value to prefill the form
                     
            if(Array.isArray(display)){//if value is array, join values
                display = display.join(", ");
            }

            Object.keys(schema).map((schKey, j) => {//get jsonshcema for each field
                console.log(schKey, field);
                if(schKey == field){
                    specificSchema = {
                        "type":"object",
                        "properties":{
                            [schKey]: schema[schKey]
                        }
                    };//..., properties:{Age:{title: "Age", type: "integer", minimum: 16, maximum: 100}}

                    formDatas = {
                        [field]:values[field]
                    };//{"Age":24} = old/DB value
                }
                return;
            });

            if(ui !== null){
                Object.keys(ui).map((uiKey) => {//get uishcema for each field
                    if(uiKey == field){
                        specificUi = {
                            [uiKey]:ui[uiKey]
                        };
                        //{Age: { ui: widget:"range"}}
                    }
                    return;
                });

            } else {
                specificUi = ""
            }

            return[
                specificSchema,
                specificUi,
                formDatas         
            ]

        }
    }
    handleSubmit= async ({formData}) => {
        //HERE formData is an attribute from the result object of the form
        console.log("[INFO] SUBMIT",formData);
        try {
            var idInfo = this.props.userId;
            if (idInfo === ''){
                idInfo = this.props.boxId;
            }
            const infos = await fetch('/schema/updateUser',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    "data":formData,
                    "userID": idInfo,
                    "idSchema":this.props.InfoItem
                }),
                
                credentials: 'same-origin',
            });
            let body = await infos.json();                
            console.log("[INFO] submit update profile user", body);  
            if(body.errorCode === 200){
                this.setState({
                    openNewEquip: false
                })
                this.getGenercisInfo()
            }

        } catch (error) {
            console.log("[ERROR] submit update profile user",error)
            return
        }
        
    }
    render() {
        const { info, update, showUpdateForm, openNewEquip} = this.state;      
        console.log('[DEBUG], RENDER,Info Equipment USER , info : ', this.state);
        let infoEquipAC = [];
        let infoEquipDC = [];
        let titles ={
            "equipementTyp": "Type Equipement",
            "powerEq": "Puissance",
            "brandEq": "Marque",
            "quantity": "Quantité"
        }
        let row = '';
        if (this.state.AC) {
            for (row = 0; row< this.state.AC.length; row++ ){
                    
                    infoEquipAC.push(
                        <tr>
                            <td>{this.state.AC[row]["equipementTyp"]}</td>
                            <td>{this.state.AC[row]["powerEq"]}</td>
                            <td>{this.state.AC[row]["brandEq"]}</td>
                            <td>{this.state.AC[row]["quantity"]}</td>
                        </tr>
                    );
                    
                
            }
        }
        if (this.state.DC) {
            
            for (row = 0; row< this.state.DC.length; row++ ){
                    infoEquipDC.push(
                        <tr>
                            <td>{this.state.DC[row]["equipementTyp"]}</td>
                            <td>{this.state.DC[row]["powerEq"]}</td>
                            <td>{this.state.DC[row]["brandEq"]}</td>
                            <td>{this.state.DC[row]["quantity"]}</td>
                        </tr>
                    );
                    
            }
        }
        
        let datas = []
        datas["ac"] = this.state.values.ac

        let datasDC = []
        datasDC["dc"] = this.state.values.dc
        const formEquip = (
            <div>
                <Form
                    schema={this.state.formType === "ac" ? this.state.formAC : this.state.formDC}
                    // uiSchema={}
                    formData={this.state.formType === "ac" ? datas :datasDC}
                    onSubmit={this.handleSubmit}
                >
                
                    <Button type="submit" variant="contained" color="primary" >
                        Valider
                    </Button>
                    <Button type="button" onClick={() => this.setState({
                        openNewEquip: false,
                    }) }
                    >
                        Annuler
                    </Button>
                        
                </Form>
            </div>
        )

        return (
            <MiniCard 
                title={this.state.ItemName}
                action={
                    <IconButton onClick={this.getSchema} color="primary" >
                        {update ? <Close /> : <Create />}
                    </IconButton>
                }
                avatar={<Settings />}
            >
                {this.state.openNewEquip &&
                    <Dialog 
                        block={true}
                        title="Ajouter un equipement"
                        text={formEquip}
                        // notOk={true} ??
                        close={() => {
                            this.setState({ openNewEquip: false })
                        }}
                    />
                }
                {info && 
                <Box>
                    
                    {!this.state.AC && !this.state.DC ?
                        <DisplayUserInfo
                            {...this.state}
                            updateInfo={this.updateInfo}
                            handleSubmit={this.handleSubmit}
                            updateTarget={(target) => this.setState({
                                showUpdateForm: target
                            })}

                        />
                    :
                    <Box p={1} >
                        <h4>Equipement AC</h4>
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th">Type</TableCell>
                                    <TableCell component="th">Marque</TableCell>
                                    <TableCell component="th">Puissance</TableCell>
                                    <TableCell component="th">Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {infoEquipAC}
                            </TableBody>
                        </TableLayout>
                        {this.state.update &&
                            <Box className="text-center">
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={()=>this.setState({
                                        openNewEquip: true,
                                        formType:"ac"
                                    }) }
                                >
                                    Ajouter
                                </Button>
                            </Box>
                        }
                        <h4>Equipement DC</h4>
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th">Type</TableCell>
                                    <TableCell component="th">Marque</TableCell>
                                    <TableCell component="th">Puissance</TableCell>
                                    <TableCell component="th">Quantité</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {infoEquipDC}
                            </TableBody>
                        </TableLayout>
                        {this.state.update &&
                            <Box className="text-center">
                                <Button 
                                    color="secondary"
                                    variant="contained" 
                                    onClick={()=>this.setState({
                                        openNewEquip: true,
                                        formType:"dc"
                                    }) }
                                >
                                    Ajouter
                                </Button>
                            </Box>
                        }
                    </Box>
                    }

                </Box>
                }
            
            </MiniCard>
        )
    }
}

export default ProfileItemGenerics
